export class MoveEventsToBerthCallFactory {
    constructor() {}

    public createMoveEventsToBerthCallBM(
        imoNumber: number,
        portCallId: number,
        fromBerthCallId: number,
        toBerthCallId: number,
        toBerthId: number | null,
        toBerthSequenceNumber: number | null,
        user: string
    ): any {
        return {
            imoNumber: imoNumber,
            portCallId: portCallId,
            fromBerthCallId: fromBerthCallId,
            toBerthCallId: toBerthCallId,
            toBerthId: toBerthId,
            toBerthSequenceNumber: toBerthSequenceNumber,
            user: user,
        };
    }
}
